<template>
    <div class="section-no-padding carousel-home">
        <carousel :navigationEnabled="false" :paginationEnabled="true" :per-page="1" autoplay :autoplayTimeout="5000" loop :mouse-drag="false" ref="carousel" class="carousel">
            <slide v-for="(item, index) in items" :key="index" class="slide">
                <div v-html="item.img_html"></div>
                <div class="overlay">
                    <transition-slide-toggle>
                        <div v-show="index === current">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-10 col-lg-6">
                                        <h1>{{ item.title }}</h1>
                                        <template v-if="item.button_url && item.button">
                                            <a :href="item.button_url" class="btn btn-primary btn-caret">{{ item.button }}</a>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-slide-toggle>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>

    export default {
        props: {
            items: Array
        },
        data() {
            return {
                current: 0,
            }
        },
        mounted() {
            let that = this;
            this.$watch(
                () => {
                    return this.$refs.carousel.currentPage
                },
                val => {
                    that.current = val;
                }
            )
        },
    }
</script>

<style scoped>

    .carousel >>> .VueCarousel-inner {
        transition-delay: .3s !important;
    }

    .slide-enter-active {
        animation: slide-in .5s forwards .5s;
    }

    .slide-leave-active {
        animation: slide-out .5s forwards;
    }


    @keyframes slide-in {
        0% {
            transform: translateY(100px);
            opacity: 0;
        }
        100% {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0px);
            opacity: 1;
        }
        100% {
            transform: translateY(-100px);
            opacity: 0;
        }
    }
</style>
